"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseUri = require("../Support/BaseUri");
var _q = require("../Support/Query");
var Request_1 = require("../Support/Request");
var Grid = require("./Grid");
function colorway(_a) {
    var designCode = _a.designCode, colorCode = _a.colorCode, roomId = _a.roomId, installId = _a.installId, pixels = _a.pixels, surfaceRotation = _a.surfaceRotation;
    return BaseUri.compose()
        .segment([
        'designs', designCode,
        'colors', colorCode,
        'rooms', "" + roomId,
        'installs', "" + installId
    ])
        .query(__assign({}, _q.parseArg('pixels', pixels), _q.parseArg('surfaceRotation', surfaceRotation)))
        .toString();
}
exports.colorway = colorway;
function colorwayAreaRug(_a) {
    var designCode = _a.designCode, colorCode = _a.colorCode, roomId = _a.roomId, areaRugArgs = __rest(_a, ["designCode", "colorCode", "roomId"]);
    return BaseUri.compose()
        .segment([
        'designs', designCode,
        'colors', colorCode,
        'arearug',
        'rooms', "" + roomId,
    ])
        .query(_q.areaRug(areaRugArgs))
        .toString();
}
exports.colorwayAreaRug = colorwayAreaRug;
function recolor(_a) {
    var designCode = _a.designCode, roomId = _a.roomId, installId = _a.installId, pixels = _a.pixels, surfaceRotation = _a.surfaceRotation, recolorArgs = __rest(_a, ["designCode", "roomId", "installId", "pixels", "surfaceRotation"]);
    return BaseUri.compose()
        .segment([
        'designs', designCode, 'recolor',
        'rooms', "" + roomId,
        'installs', "" + installId
    ]).query(__assign({}, _q.recolor(recolorArgs), _q.parseArg('pixels', pixels), _q.parseArg('surfaceRotation', surfaceRotation)))
        .toString();
}
exports.recolor = recolor;
function recolorAreaRug(_a) {
    var designCode = _a.designCode, roomId = _a.roomId, restArgs = __rest(_a, ["designCode", "roomId"]);
    return BaseUri.compose()
        .segment([
        'designs', designCode, 'recolor',
        'arearug', 'rooms', "" + roomId
    ]).query(__assign({}, _q.recolor(restArgs), _q.areaRug(restArgs)))
        .toString();
}
exports.recolorAreaRug = recolorAreaRug;
function rug(_a) {
    var roomId = _a.roomId, args = __rest(_a, ["roomId"]);
    return BaseUri.compose()
        .segment(['rug', 'rooms', "" + roomId])
        .query(_q.rug(args))
        .toString();
}
exports.rug = rug;
function collection(_a) {
    var collectionCode = _a.collectionCode, pixels = _a.pixels, surfaceRotation = _a.surfaceRotation;
    return BaseUri.compose()
        .segment([
        'collections', collectionCode, 'room'
    ])
        .query(__assign({}, _q.parseArg('pixels', pixels), _q.parseArg('surfaceRotation', surfaceRotation)))
        .toString();
}
exports.collection = collection;
function grid(request) {
    return __awaiter(this, void 0, void 0, function () {
        var url, fileName;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    url = BaseUri.compose()
                        .segment(['grids', 'room'])
                        .toString();
                    return [4 /*yield*/, Request_1.postJson(url, request)];
                case 1:
                    fileName = (_a.sent()).fileName;
                    return [2 /*return*/, Grid.image(fileName)];
            }
        });
    });
}
exports.grid = grid;
function backgroundImage(roomId, pixels) {
    return BaseUri.compose()
        .segment(['rooms', "" + roomId, 'background.jpg'])
        .query(_q.parseArg('pixels', pixels))
        .toString();
}
exports.backgroundImage = backgroundImage;
function sceneXml(roomId) {
    return BaseUri.compose()
        .segment(['rooms', "" + roomId, 'scene.xml'])
        .toString();
}
exports.sceneXml = sceneXml;
function roomImage(roomId, image, pixels) {
    return BaseUri.compose()
        .segment(['rooms', "" + roomId, 'image', image])
        .query(_q.parseArg('pixels', pixels))
        .toString();
}
exports.roomImage = roomImage;
